import React from "react";
import { Grid, Paper, Stack, Typography, Box } from "@mui/material";
import { useNavigate } from "react-router-dom";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import TrendingDownIcon from "@mui/icons-material/TrendingDown";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import GroupsIcon from "@mui/icons-material/Groups";
import PersonIcon from "@mui/icons-material/Person";
import DescriptionIcon from "@mui/icons-material/Description";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

const LINK_BY_LABEL = {
  "Total Courses":        "/admin/course-list",
  "Groups":               "/admin/resource-allocation",
  "Active Batches":       "/admin/resource-allocation",
  "Active Classes":       "/admin/resource-allocation",
  "Enrolled Students":    "/admin/students",
  "Worksheets Assigned":  "/admin/resource-allocation",
  "Worksheets Completed": "/admin/resource-allocation",
};

const BADGE_BY_LABEL = {
  "Total Courses":        { Icon: MenuBookIcon,    bg: "#ede9fe", fg: "#7c3aed" },
  "Groups":               { Icon: GroupsIcon,      bg: "#dcfce7", fg: "#16a34a" },
  "Active Batches":       { Icon: GroupsIcon,      bg: "#dcfce7", fg: "#16a34a" },
  "Active Classes":       { Icon: GroupsIcon,      bg: "#dcfce7", fg: "#16a34a" },
  "Enrolled Students":    { Icon: PersonIcon,      bg: "#dbeafe", fg: "#2563eb" },
  "Worksheets Assigned":  { Icon: DescriptionIcon, bg: "#fef3c7", fg: "#d97706" },
  "Worksheets Completed": { Icon: CheckCircleIcon, bg: "#cffafe", fg: "#0891b2" },
};

const DEFAULT_CARDS = [
  { label: "Total Courses", value: "—", delta: 0, delta_label: "" },
  { label: "Groups", value: "—", delta: 0, delta_label: "" },
  { label: "Enrolled Students", value: "—", delta: 0, delta_label: "" },
  { label: "Worksheets Assigned", value: "—", delta: 0, delta_label: "" },
  { label: "Worksheets Completed", value: "—", delta: 0, delta_label: "" },
];

export default function KpiCards({ cards }) {
  const navigate = useNavigate();
  const items = cards || DEFAULT_CARDS;
  return (
    <Grid container spacing={2}>
      {items.map((card) => {
        const cfg = BADGE_BY_LABEL[card.label] || BADGE_BY_LABEL["Total Courses"];
        const Icon = cfg.Icon;
        const up = (card.delta ?? 0) >= 0;
        const href = LINK_BY_LABEL[card.label];
        return (
          <Grid item xs={12} sm={6} md={4} lg={2.4} key={card.label}>
            <Paper
              onClick={href ? () => navigate(href) : undefined}
              sx={{
                p: 2,
                borderRadius: 3,
                boxShadow: "0 4px 12px rgba(0,0,0,0.04)",
                border: "1px solid #eef0f4",
                cursor: href ? "pointer" : "default",
                "&:hover": href ? { boxShadow: "0 6px 20px rgba(0,0,0,0.08)" } : {},
              }}
            >
              <Stack direction="row" spacing={1.5} alignItems="center">
                <Box
                  sx={{
                    width: 48, height: 48, borderRadius: "50%",
                    bgcolor: cfg.bg, color: cfg.fg,
                    display: "flex", alignItems: "center", justifyContent: "center",
                  }}
                >
                  <Icon />
                </Box>
                <Box sx={{ minWidth: 0 }}>
                  <Typography variant="caption" sx={{ color: "#374151", fontWeight: 700 }} noWrap>{card.label}</Typography>
                  <Typography variant="h5" fontWeight={800} sx={{ lineHeight: 1.1, color: "#111827" }}>
                    {typeof card.value === "number" ? card.value.toLocaleString() : card.value}
                  </Typography>
                  <Stack direction="row" alignItems="center" spacing={0.5}>
                    {up ? (
                      <TrendingUpIcon sx={{ fontSize: 14, color: "#16a34a" }} />
                    ) : (
                      <TrendingDownIcon sx={{ fontSize: 14, color: "#dc2626" }} />
                    )}
                    <Typography variant="caption" sx={{ color: up ? "#16a34a" : "#dc2626", fontWeight: 700 }}>
                      {Math.abs(card.delta ?? 0)} {card.delta_label}
                    </Typography>
                  </Stack>
                </Box>
              </Stack>
            </Paper>
          </Grid>
        );
      })}
    </Grid>
  );
}
